import React from 'react';
import './App.css';
import GameBoard from './components/GameBoard';
import './i18n';

function App() {
  return (
    <div className="App">
      <GameBoard />
    </div>
  );
}

export default App;
